import script from "./Physics1.vue?vue&type=script&setup=true&lang=js"
export * from "./Physics1.vue?vue&type=script&setup=true&lang=js"

import "./Physics1.vue?vue&type=style&index=0&id=206c4be9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206c4be9"]])

export default __exports__